import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import moment from 'moment'

import Menu from '../../Shared/Menu'
import { formatEventSubheadlineLocation } from '../../../utils/helpers'

import moreDots from '../../../images/icons/more_horiz.svg'
import { VenueIcon, ClockIcon, PinIcon, TickWrappedIcon } from '../../../images'

export default function EventHeader({ event, showActiveBadge = true, menuOptions = [], children = null, classes, showMenu = null }) {
    const { t } = useTranslation()
    const [dotsMenuOpen, setDotsMenuOpen] = useState(false)
    const isCampaignActive = useMemo(() => showActiveBadge && (moment(event.date) > moment()), [event, showActiveBadge])

    if (!event) return null // FIXME: loading skeleton or empty view?

    return (
        <header className={`event-header p-0 ${classes}`}>
            <div className="row">
                <div className="col">
                    <h1 className="event-title" title={event.title}>{event.title}</h1>
                    <p className="insights-header__text d-flex">
                        <span className='mr-2'>
                            <span>
                                <ClockIcon className='mr-1' height={12} width={12}/>
                            </span>
                            <time dateTime={moment.utc(event.date).format('DD.MM.YYYY, HH:mm')}>  {/* FIXME: Inconsistent time parsing & formatting? */}
                                {moment.utc(event.date).format('DD.MM.YYYY, HH:mm')} {/* FIXME: Inconsistent time parsing & formatting? */}
                            </time>
                        </span>
                        <span className='mr-2'>
                            <span>
                                <PinIcon className='mr-1' height={12} width={17}/>
                            </span>
                            <span>{
                                formatEventSubheadlineLocation({
                                    city: event.city,
                                })
                            }</span>
                        </span>
                        <span>
                            <span>
                                <VenueIcon className='mr-1' height={12} width={17} />
                            </span>
                            <span>{
                                formatEventSubheadlineLocation({
                                    hall: event.hall_name,
                                    venue: event.venue_name
                                })
                            }</span>
                        </span>
                    </p>
                    {children}
                    {showActiveBadge && event.has_active_campaigns && (
                        <span
                            className={`event-row_left-content_title-and-date_date_active-campaign-indicator_wrapper ${isCampaignActive ? 'green': 'red'}`}
                            style={{ marginLeft: 0, height: '20px' }}
                        >
                            <span><TickWrappedIcon width={12} /></span>
                            <span className="event-row_left-content_title-and-date_date_active-campaign-indicator_text">
                                {isCampaignActive ? t('Recommendations.campaignBadge.active') : 
                                    t('Recommendations.campaignBadge.inactive')}
                            </span>
                        </span>
                    )}
                    <div className='mt-2' style={{ color: '#616060', textAlign: 'left' }}>
                        {event.eid && event.eid.includes('-sim-') ? <><div className='mb-1'>{t('Event.manual')}</div><br /></> : <br />}
                    </div>
                </div>
            </div>
            {showMenu && <div className="col-auto">
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    {menuOptions.length > 0 &&
                        <div
                            className="event-header_more-dots_wrapper"
                            onClick={(e) => e.stopPropagation()}
                            style={{ borderRight: 'none', position: 'relative' }}

                        >
                            <div className="event-header_more-dots-button c-hover">
                                <img
                                    style={{ width: 32 }}
                                    src={moreDots}
                                    alt='Campaign options'
                                    onClick={() => setDotsMenuOpen(true)}
                                />
                            </div>
                            <Menu
                                open={dotsMenuOpen}
                                toggleMenu={setDotsMenuOpen}
                                options={menuOptions}
                                classNames="dots-menu_wrapper--expandable"
                            />
                        </div>
                    }
                </div>
            </div>}
        </header>
    )
}

EventHeader.propTypes = {
    event: PropTypes.object.isRequired,
    menuOptions: PropTypes.array,
    showActiveBadge: PropTypes.bool,
    children: PropTypes.node,
    classes: PropTypes.string,
    showMenu: PropTypes.bool
}
